import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';

const state = () => ({
    data: [],
    permissions:[],
    loading: false,
    error: null,
    totalRecords: 0,
});

const actions = {
    async roleReadAll({ commit }, data) {

        commit('roleReadAllBegin');
        await DataService.get(`/roles?${new URLSearchParams(data).toString()}`).then((response) => {

            commit('roleReadAllSuccess', response.data.data);
        }).catch((err) => {
            commit('roleReadAllErr', err);
        });
    },

    async permissionReadAll({ commit }, requestParams) {
        try {
            const response = await DataService.get(`/permissions?${new URLSearchParams(requestParams).toString()}`);
            commit('permissionReadAllSuccess', response.data.data);
        } catch (err) {
            commit('permissionReadAllErr', err);
        }
    },

    async roleAdd({ commit }, data) {
        commit('roleAddBegin');
        await DataService.post('/roles', data).then(() => {
            commit('roleAddSuccess');
        }).catch(err => {
            commit('roleAddErr', err);
        });
    },

    async roleUpdate({ commit }, data) {
        commit('roleUpdateBegin');
        await DataService.put(`/roles/${data.id}`, data).then(response => {
            commit('roleUpdateSuccess', response.data.data);
        }).catch(err => {
            commit('roleUpdateErr', err);
        });
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};